import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 16,
			x2: 12,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 8,
			x2: 12.01,
			y2: 8
		})
	]
});
export default SvgInfoCircle;
